import { Scanner as ScannerComponent } from "@yudiel/react-qr-scanner";
import { Box } from "@/ui";
import { keyframes } from "@emotion/react";
import ScannerFrame from "assets/icons/scanner_frame.svg?react";

const FRAME_SIZE = 255;
const SCAN_LINE_OFFSET = 6;
const SCAN_LINE_WIDTH = 320;
const SCAN_LINE_HEIGHT = 8;
const SCAN_LINE_RADIUS = 80;
const SCAN_LINE_END = FRAME_SIZE - SCAN_LINE_HEIGHT - SCAN_LINE_OFFSET;

const scanAnimation = keyframes`
  0%, 100% { transform: translate(-50%, ${SCAN_LINE_OFFSET}px); }
  50% { transform: translate(-50%, ${SCAN_LINE_END}px); }
`;

export default function Scanner({
  handleScan,
  handleScannerError
}: {
  handleScan: (result: { rawValue: string }[]) => void;
  handleScannerError: (error: unknown) => void;
}) {
  return (
    <>
      <ScannerComponent
        onScan={handleScan}
        onError={handleScannerError}
        scanDelay={500}
        allowMultiple={false}
        components={{ finder: false }}
        constraints={{
          facingMode: { ideal: "environment" },
          width: { ideal: 1280 },
          height: { ideal: 720 }
        }}
        sound={false}
        styles={{
          container: { position: "absolute", inset: 0, zIndex: -2, transform: "scaleX(-1)" },
          video: { objectFit: "cover" }
        }}
      />
      <Box position="relative" zIndex={-1} w={`${FRAME_SIZE}px`} h={`${FRAME_SIZE}px`}>
        <Box
          position="absolute"
          inset={0}
          borderRadius="20px"
          pointerEvents="none"
          sx={{
            boxShadow: "0 0 10000px 10000px rgba(0, 0, 0, 0.4), inset 0 0 0 3px rgba(0, 0, 0, 0.4)"
          }}
        />
        <ScannerFrame
          style={{
            position: "relative",
            zIndex: 1
          }}
        />
        <Box
          position="absolute"
          left="50%"
          top={0}
          transform={`translate(-50%, ${SCAN_LINE_OFFSET}px)`}
          w={`${SCAN_LINE_WIDTH}px`}
          h={`${SCAN_LINE_HEIGHT}px`}
          color="primary"
          bg="primary"
          borderRadius={`${SCAN_LINE_RADIUS}px`}
          sx={{
            zIndex: 2,
            overflow: "visible",
            willChange: "transform",
            animation: `${scanAnimation} 2s linear infinite`,
            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              borderRadius: `${SCAN_LINE_RADIUS}px`,
              background: "currentColor",
              filter: "blur(32px)",
              opacity: 0.9,
              zIndex: 0,
              pointerEvents: "none"
            }
          }}
        />
      </Box>
    </>
  );
}
